export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const HOME_PATH = '/v1';

export const CATEGORY_PATH_PREFIX = 'streameast';

/** Build a category URL, e.g. /streameast-Soccer */
export const getCategoryPath = (label: string) => `/${CATEGORY_PATH_PREFIX}-${label}`;


export const PAGE_TITLES: any = {
  WEBSITE_TITLE: 'Stream east soccer | Free Live HD Sports Streaming – NFL, NBA, F1, Boxing, UFC & More | streameast7.org',
  FOOTBALL: 'Stream east soccer - Live Soccer Streams, Match Highlights & Upcoming Fixtures | streameast7.org',
  BOXING: 'Stream east soccer - Live Boxing Streams & Upcoming Fight Schedule | streameast7.org',
  SOCCER: 'Stream east soccer - Live Soccer Streams, Match Highlights & Upcoming Fixtures | streameast7.org',
  NFL: 'Stream east soccer - Watch NFL Live Streams & Upcoming NFL Games | streameast7.org',
  NBA: 'Stream east soccer - Live NBA Streams, Fixtures & Game Coverage | streameast7.org',
  UFC: 'Stream east soccer - UFC Live Streams, UFC 315 & Upcoming Fight Cards | streameast7.org',
  MMA: 'Stream east soccer - MMA & UFC Live Streams with Upcoming Events | streameast7.org',
  TENNIS: 'Stream east soccer - Live Tennis Streams & Upcoming Tournament Fixtures | streameast7.org',
  RUGBY: 'Stream east soccer - Rugby Live Streams & Upcoming Match Schedule | streameast7.org',
  MOTOGP: 'Stream east soccer - MotoGP Live Streams & Race Calendar | streameast7.org',
  NHL: 'Stream east soccer - NHL Live Streams & Season Fixtures | streameast7.org',
  MLB: 'Stream east soccer - MLB Live Streams, Playoffs & Upcoming Games | streameast7.org',
  F1: 'Stream east soccer - Formula 1 Live Streams & Race Fixtures | streameast7.org',
  MLS: 'Stream east soccer - MLS Live Streams & Upcoming Matches | streameast7.org',
  CRICKET: 'Stream east soccer - Live Cricket Streams, Matches & Schedule | streameast7.org',
  TEAMS: 'Stream east soccer - Explore Fixtures for Popular Teams | streameast7.org',
  LEAGUES: 'Stream east soccer - Live Fixtures & Updates from Top Leagues | streameast7.org',
  STANDINGS: 'Stream east soccer - Live Standings: Champions League, Serie A, La Liga, Ligue 1 & Bundesliga | streameast7.org',
  CONTACT: 'Stream east soccer - Contact Us | streameast7.org',
  ABOUT: 'Stream east soccer - About Us, Our Mission & Vision | streameast7.org'
}

export const DIRECT_PLAYERS = [
  'TNT SPORTS FHD'
];

export const GREEN_PLAYER_SOURCES = [
  'Reddit-SoccerStreams', 
  'Reddit-Streams', 
  'ESPN 2 USA', 
  'TNT Sports 2 Uk', 
  'ESPN 2 USA', 
  'Full Hd Sports',
  'wow STREAM',
  'NBA TV',
  'NBA TV USA'
]
export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!',
  ADD_MATCH_SUCCESS: 'Match added successfully!',
  ADD_MATCH_FAILURE: 'Failed to add match!',
}

export const CATEGORY_LINKS:any = {
  Soccer: '/streameast-Soccer',
  F1: '/streameast-F1',
  UFC: '/streameast-UFC',
  'BOXING|UFC': '/streameast-Boxing',
  BOXING: '/streameast-Boxing',
  TENNIS: '/streameast-Tennis',
  NBA: '/streameast-NBA',
  NFL: '/streameast-NFL',
  RUGBY: '/streameast-Rugby',
  CRICKET: '/streameast-Cricket',
  MOTOGP: '/streameast-Motogp'
};

export const categories = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'Tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'Motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  // {
  //   label: 'MLB',
  //   value: 'MLB'
  // },
  // {
  //   label: 'NHL',
  //   value: 'NHL'
  // },
  {
    label: 'Rugby',
    value: 'Rugby'
  }
  // {
  //   label: 'Cricket',
  //   value: 'cricket'
  // }
];

export const MENU_CATEGORIES = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'Tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'Motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  // {
  //   label: 'MLB',
  //   value: 'MLB'
  // },
  // {
  //   label: 'NHL',
  //   value: 'NHL'
  // },
  {
    label: 'Rugby',
    value: 'Rugby'
  }
  // {
  //   label: 'Cricket',
  //   value: 'cricket'
  // }
];

export const NOT_SOCCER = ['tennis', 'cricket', 'f1', 'boxing|ufc', 'nfl', 'motogp','nba', 'nhl', 'mlb', 'rugby', 'wwe','ufc'];

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const DEFAULT_LEAGUE_LINK = '/leagues/Premier League/645bec5ba42012fa6eb37334';
export const DEFAULT_TEAM_LINK = '/teams/Liverpool/6455eab25477a7f3d047a4cc';
export const DEFAULT_IMAGE_PATH = 'https://res.cloudinary.com/djfixkqyj/image/upload/v1709307398/Images/Default-Sports-Logo_luku1o.webp'
